var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownloadFilteredClaimsCancelicon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C4.134 15 1 11.865 1 8C1 4.135 4.134 1 8 1C11.866 1 15 4.135 15 8C15 11.865 11.866 15 8 15ZM8 0C3.5815 0 0 3.58 0 8C0 12.42 3.5815 16 8 16C12.4185 16 16 12.42 16 8C16 3.58 12.4185 0 8 0ZM10.8585 5.14001C10.6615 4.94501 10.343 4.94501 10.146 5.14001L7.99701 7.28998L5.879 5.16998C5.6835 4.97498 5.3665 4.97498 5.172 5.16998C4.9765 5.36498 4.9765 5.685 5.172 5.88L7.29001 7.995L5.15701 10.13C4.96051 10.325 4.96051 10.645 5.15701 10.845C5.35401 11.04 5.673 11.04 5.87 10.845L8.00299 8.71002L10.121 10.83C10.3165 11.025 10.6335 11.025 10.8285 10.83C11.024 10.635 11.024 10.315 10.8285 10.12L8.70999 8.005L10.8585 5.85498C11.055 5.65498 11.055 5.34001 10.8585 5.14001Z",
    fill: "#201B7C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadFilteredClaimsCancelicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DownloadFilteredClaimsCancelicon.9146e6ef.svg";
export { ForwardRef as ReactComponent };